import { render, staticRenderFns } from "./TransferenciaCompraExterna.vue?vue&type=template&id=01adda1d&scoped=true&"
import script from "./TransferenciaCompraExterna.vue?vue&type=script&lang=js&"
export * from "./TransferenciaCompraExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01adda1d",
  null
  
)

export default component.exports